/**
 * Chronos globaux de donne Live (PlayingGameTiming côté Java).
 * Valeurs lues sur le serveur Live : /home/java/live/data/server*.txt
 *
 * Le proxy Java peut aussi envoyer `tempsDonne` — s'il est présent, il prime.
 */
export const LIVE_DEAL_TIMEOUTS: Record<number, { attaquant: number; defenseur: number }> = {
  2200: { attaquant: 155, defenseur: 130 },
  2201: { attaquant: 130, defenseur: 125 },
  2202: { attaquant: 120, defenseur: 100 },
  2203: { attaquant: 135, defenseur: 125 }, // Live Compétition
};

export function parseLivePort(tableId?: string, port?: number): number | undefined {
  if (port && LIVE_DEAL_TIMEOUTS[port]) return port;
  if (!tableId) return undefined;
  const match = tableId.match(/:(\d+)$/);
  if (!match) return undefined;
  const parsed = Number(match[1]);
  return LIVE_DEAL_TIMEOUTS[parsed] ? parsed : undefined;
}

/**
 * Durée du chrono de donne si le proxy n'envoie pas `tempsDonne`.
 * Sur Live, timeout_attaquant s'applique quand le preneur prédéterminé
 * est Sud (contratObligatoire > 0 pour le joueur en Sud).
 */
export function resolveLiveDealTimeoutSeconds(opts: {
  tableId?: string;
  port?: number;
  contratObligatoire?: number;
}): number | undefined {
  const livePort = parseLivePort(opts.tableId, opts.port);
  if (livePort === undefined) return undefined;
  const limits = LIVE_DEAL_TIMEOUTS[livePort];
  const cO = opts.contratObligatoire;
  const isAttaquant = cO !== undefined && cO > 0 && cO !== 255;
  return isAttaquant ? limits.attaquant : limits.defenseur;
}
